import anime from './anime'

function animateFallUp(elementRef, onComplete) {
  // animate destroy in threejs
  const transformation = {
    positionY: elementRef.current.position.y
  };
  anime(
    {
      easing: 'easeInBack',
      duration: 1024,
      positionY: 10,
      targets: transformation,
      update: function () {
        if(!elementRef.current) return
        elementRef.current.position.y = transformation.positionY;
      },
      complete: onComplete,
    }
  )
}

export default animateFallUp
